import type { UserAgreementType, VaultAddress, } from "@bracket/types";
import { gql, } from "./gql";

export const agree = async ( agreement: UserAgreementType, vault?: VaultAddress, ): Promise<boolean> => {
	const response = await gql<{ agree: boolean; }>("AGREE", agreement, vault);
	if(response) {
		return response.agree;
	}
	console.warn("wallet::agree:: failed to agree", agreement, vault);
	return false;
}
